// Permisos RBAC de la pantalla Cartera. Sin `loan.credit.read` la pantalla no se muestra y el
// item del sidebar queda oculto.

/** Va como `string`: `PermissionKey`, generado del OpenAPI, no expone claves de dominio. */
export const PORTFOLIO_PERMISSIONS = {
    readCredit: 'loan.credit.read',
} as const;

export type PortfolioPermissionKey =
    (typeof PORTFOLIO_PERMISSIONS)[keyof typeof PORTFOLIO_PERMISSIONS];

export interface PortfolioAbilities {
    canReadCredit: boolean;
}

/**
 * Toma el set de permisos como `ReadonlySet<string>` —y no como `PermissionKey`— porque el union
 * generado del OpenAPI no incluye las claves de dominio: comparar contra él no compila.
 */
export function resolvePortfolioAbilities(
    grantedPermissions: ReadonlySet<string>,
): PortfolioAbilities {
    return { canReadCredit: grantedPermissions.has(PORTFOLIO_PERMISSIONS.readCredit) };
}
